import { useState } from 'react';
import { Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { downloadLeadSheet } from '../api/downloadLeadSheet';

interface PrintLeadSheetButtonProps {
  leadId: number;
  jobNumber?: string;
  onError?: (error: string) => void;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
}

/**
 * Button component for printing/downloading lead sheet PDF
 * Fetches PDF from API and opens in new tab or triggers download
 */
export function PrintLeadSheetButton({
  leadId,
  jobNumber,
  onError,
  variant = 'outline',
  size = 'default',
  className,
}: PrintLeadSheetButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handlePrint = async () => {
    setIsLoading(true);
    try {
      await downloadLeadSheet(leadId, jobNumber);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to generate lead sheet';
      if (onError) {
        onError(errorMessage);
      } else {
        alert(errorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handlePrint}
      disabled={isLoading}
      variant={variant}
      size={size}
      className={className || "gap-2"}
    >
      <Printer className="h-4 w-4" />
      {isLoading ? 'Generating...' : 'Print'}
    </Button>
  );
}
